import axios from './axios';

export const printClient = {
  async listPrinters(config = {}) {
    const { data } = await axios.get('/print/printers', config);
    return data?.items || [];
  },

  async createJobs({ accountId, printerUid, documentType, sourceIds, idempotencyKey }) {
    const { data } = await axios.post('/print/jobs', {
      account_id: Number(accountId),
      printer_uid: printerUid,
      document_type: documentType,
      source_ids: sourceIds,
    }, {
      headers: idempotencyKey ? { 'Idempotency-Key': idempotencyKey } : undefined,
    });
    return data;
  },

  async createMsProductBarcode({
    printerUid,
    productId,
    copies = 1,
    productName,
    colorLabel,
    labelFormat,
    idempotencyKey,
  }) {
    const { data } = await axios.post('/print/jobs/ms-product-barcode', {
      printer_uid: printerUid,
      product_id: productId,
      copies,
      product_name: productName,
      color_label: colorLabel,
      label_format: labelFormat,
    }, {
      headers: idempotencyKey ? { 'Idempotency-Key': idempotencyKey } : undefined,
    });
    return data;
  },

  async createBatch({ accountId, printerUid, documents, idempotencyKey }) {
    const { data } = await axios.post('/print/jobs', {
      account_id: Number(accountId),
      printer_uid: printerUid,
      documents,
    }, {
      headers: idempotencyKey ? { 'Idempotency-Key': idempotencyKey } : undefined,
    });
    return data;
  },

  async createFulfillmentMassBatch({
    accountId,
    printerUid,
    orderedSourceIds,
    idempotencyKey,
  }) {
    const { data } = await axios.post('/print/jobs', {
      account_id: Number(accountId),
      printer_uid: printerUid,
      document_type: 'fulfillment_mass_batch',
      source_ids: orderedSourceIds,
    }, {
      headers: { 'Idempotency-Key': idempotencyKey },
    });
    return data;
  },

  async listJobs(params = {}, config = {}) {
    const { data } = await axios.get('/print/jobs', { ...config, params });
    return data;
  },

  async listRecentProductLabels() {
    const { data } = await axios.get('/print/jobs/recent-product-labels');
    return data?.items || [];
  },

  async reprintProductLabel(jobId, printerUid) {
    const { data } = await axios.post(`/print/jobs/${encodeURIComponent(jobId)}/reprint-product-label`, {
      printer_uid: printerUid,
    });
    return data?.job;
  },

  async reprint(jobId, printerUid) {
    const { data } = await axios.post(`/print/jobs/${encodeURIComponent(jobId)}/reprint`, {
      printer_uid: printerUid,
    });
    return data?.job;
  },

  async getJob(jobId, config = {}) {
    const { data } = await axios.get(`/print/jobs/${encodeURIComponent(jobId)}`, config);
    return data?.job || null;
  },

  async cancelJob(jobId) {
    const { data } = await axios.post(`/print/jobs/${encodeURIComponent(jobId)}/cancel`);
    return data?.job || null;
  },

  async openMassPdf(jobId) {
    const { data } = await axios.get(`/print/jobs/${encodeURIComponent(jobId)}/file`, {
      responseType: 'blob',
    });
    const url = URL.createObjectURL(data);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.target = '_blank';
    anchor.rel = 'noopener noreferrer';
    anchor.click();
    window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
  },

  async listAgents(config = {}) {
    const { data } = await axios.get('/print/agents', config);
    return data?.items || [];
  },

  async createAgent(name) {
    const { data } = await axios.post('/print/agents', { name });
    return data;
  },

  async updateAgent(agentId, changes) {
    const { data } = await axios.patch(`/print/agents/${encodeURIComponent(agentId)}`, changes);
    return data?.agent;
  },

  /** Настройки транспорта принтера: { transport, raw_host, raw_port, raw_settings }. */
  async updatePrinter(printerId, changes) {
    const { data } = await axios.patch(`/print/printers/${encodeURIComponent(printerId)}`, changes);
    return data?.printer;
  },

  async disableAgent(agentId) {
    const { data } = await axios.delete(`/print/agents/${encodeURIComponent(agentId)}`);
    return data;
  },

  async rotateAgentToken(agentId) {
    const { data } = await axios.post(`/print/agents/${encodeURIComponent(agentId)}/rotate-token`);
    return data;
  },
};

export function newPrintIdempotencyKey(prefix = 'print') {
  const random = globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`;
  return `${prefix}-${random}`;
}
